import { callApi } from '@/_core/api/apiWrapper'

export const getThemes = async () => {
  const response = await callApi({
    method: 'get',
    url: 'feedback/dictionary/'
  })
  return response
}

export const sendForm = async data => {
  if (!data) return
  const response = callApi({
    method: 'post',
    url: 'feedback/',
    formData: true,
    data
  })
  return response
}
